import { render, staticRenderFns } from "./sms-templates-x-drawer.vue?vue&type=template&id=1991e58b&scoped=true"
import script from "./sms-templates-x-drawer.vue?vue&type=script&lang=js"
export * from "./sms-templates-x-drawer.vue?vue&type=script&lang=js"
import style0 from "./sms-templates-x-drawer.vue?vue&type=style&index=0&id=1991e58b&prod&lang=scss&scoped=true"
import style1 from "./sms-templates-x-drawer.vue?vue&type=style&index=1&id=1991e58b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991e58b",
  null
  
)

export default component.exports